import { gql } from '@apollo/client';

export const GET_QUALITATIVE_FACTORS_DASHBOARD = gql`
  query GetQualitativeFactorsDashboard(
    $level: ItApplicationTypeEnum!
    $locationUUID: String!
  ) {
    getQualitativeFactorsDashboard(level: $level, locationUUID: $locationUUID) {
      applicationsTagged
      description
      isDefault
      isDirty
      lastUpdated
      name
      supportedByITApplication
      uuid
    }
  }
`;
